import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  businessBuilderBonusCoachesCount,
  businessBuilderBonusCurrentDate,
  businessBuilderBonusFQV,
} from '/redux/selector/coach.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {withProps} from '/util/selector.util';

import {BusinessBuilderBonusBanner} from './BusinessBuilderBonusBanner';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    businessBuilderBonusCoachesCount: withCurrentUserCoachId(
      businessBuilderBonusCoachesCount,
    ),
    businessBuilderBonusCurrentDate: withCurrentUserCoachId(
      businessBuilderBonusCurrentDate,
    ),
    businessBuilderBonusFQV: withCurrentUserCoachId(businessBuilderBonusFQV),
    currentScreen: currentScreen,
    userId,
    lastPaidRank: withCurrentUserCoachId(paidAsRankDescLastMonth),
  }),
  _dispatch => ({}),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
    };
  },
)(BusinessBuilderBonusBanner);
